<script>
import render from '@/render/render'
import { copy } from '@/utils'
export default {
    name: 'Collapse',
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        accordion: {
            type: Boolean,
            default: false
        },
        tabs: {
            type: Array,
            default: () => [],
        }
    },
    watch: {
        value: {
            handler(value) {
                if(Array.isArray(value)) {
                   this.info = copy(value)
                }
            },
            deep: true,
            immediate: true,
        }
    },
    data() {
        return {
            info: []
        }
    },
    render() {
        const { accordion, tabs } = this
        const setValue = (label, key, value) => {
            console.log(label, key, value)
            const data = this.info
            const item = data.find(item => item.label === label)
            if(item) {
                if(item.data) {
                    item.data[key] = value
                }
            } else {
                data.push({
                    label: label,
                    data: {
                        [key]: value
                    }
                })
            }
            this.$emit('input', data)
        }
        return (
            <el-collapse accordion={accordion}>
                {
                    tabs.map(tab => (
                        <el-collapse-item title={tab.label} name={tab.label}>
                            {
                                tab.rows.map( item => {
                                    const { __vModel__, __config__ } = item
                                    const { span, showLabel, label } = __config__
                                    let info
                                    const tabItem = this.info.find(item => item.label === tab.label)
                                    if(tabItem) {
                                        info = tabItem.data
                                    } else {
                                        info = {}
                                    }
                                    return (
                                        <el-col span={span} style="padding: 5px 0">
                                            <el-form-item label-width="120px" prop={__vModel__} label={showLabel ? label : ""}>
                                                <render info={info} conf={item} onInput={value => setValue(tab.label, __vModel__, value)} attrs={this.$attrs} />
                                            </el-form-item>
                                        </el-col>
                                    )
                                })
                            }
                        </el-collapse-item>
                    ))
                }
            </el-collapse>
        )
    }
}
</script>